import React, { useEffect, useRef } from 'react';
import './responsiveCommunication.css';

/** Keep the actual cells, inputs and actions; derive phone labels from the
 * current header, including optional columns. Never clone financial content. */
export function labelCommunicationTables(root: HTMLElement) {
  root.querySelectorAll<HTMLTableElement>(':scope > .MuiTableContainer-root > table').forEach((table) => {
    const headers = Array.from(table.tHead?.rows[0]?.cells || []);
    if (!headers.length) return;
    const labels = headers.flatMap((cell) =>
      Array(cell.colSpan).fill(cell.textContent?.trim() || '')
    );
    Array.from(table.tBodies).forEach((body) => {
      Array.from(body.rows).forEach((row) => {
        let column = 0;
        Array.from(row.cells).forEach((cell) => {
          // Spanning summaries already carry their own labels. Only regular
          // line items get header labels, and no cell content is removed.
          if (row.cells.length === headers.length && cell.colSpan === 1) {
            cell.dataset.communicationLabel = labels[column] || '';
          } else {
            delete cell.dataset.communicationLabel;
          }
          column += cell.colSpan;
        });
      });
    });
  });
}

export default function ResponsiveCommunicationTable({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    labelCommunicationTables(root);
    const observer = new MutationObserver(() => labelCommunicationTables(root));
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={`responsive-communication-table ${className}`.trim()}>{children}</div>;
}
